import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
import { queryUserTreeList } from '@api/api';
import SelectSiteCheckboxListModal from "../../assets/SelectSiteCheckboxListModal";
import { getAction, httpAction } from '@/api/manage';
import pick from 'lodash.pick';
export default {
  name: 'EntranceGuardModal',
  mixins: [ModalFormMixin],
  components: {
    SelectSiteCheckboxListModal: SelectSiteCheckboxListModal
  },
  data: function data() {
    return {
      title: '用户门禁管理表单',
      tableName: 'sys_entrance_guard',
      form_fields: ['userId', 'siteId', 'card', 'password', 'remark'],
      form_fields_time: [],
      validatorRules: {
        userId: {
          rules: [{
            required: true,
            message: '请选择用户!'
          }]
        } // card: { rules: [{ required: true, message: '请输入卡号!' }] }

      },
      // 人员信息
      userTree: [],
      selectedSiteName: [],
      selectedSiteIds: [],
      siteIds: '',
      type: '',
      url: {
        querySiteName: '/sys/entrance/guard/querySiteName/'
      }
    };
  },
  props: ['pagePath'],
  created: function created() {},
  methods: {
    loadTree: function loadTree() {
      var _this = this;

      var that = this;
      that.userTree = [];
      queryUserTreeList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.userTree.push(temp);
          }

          _this.loading = false;
        }
      });
    },
    // 子modal回调
    choseSite: function choseSite(siteList) {
      this.selectedSiteName = [];
      this.selectedSiteIds = [];
      this.siteIds = '';

      for (var i = 0; i < siteList.length; i++) {
        this.selectedSiteName.push(siteList[i].name);
        this.selectedSiteIds.push(siteList[i].id);
        this.siteIds += siteList[i].id + ',';
      }
    },
    selectSite: function selectSite() {
      this.$refs.SiteListModal.add(this.selectedSiteName, this.selectedSiteIds);
    },
    querySiteNameList: function querySiteNameList(params) {
      var that = this;
      that.selectedSiteName = [];
      getAction(this.url.querySiteName + params).then(function (res) {
        if (res.success) {
          that.selectedSiteName = res.result;
        }
      });
    },
    add: function add(type) {
      this.type = type;
      this.edit({});
    },
    edit: function edit(record) {
      var _this2 = this;

      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      this.selectedSiteName = [];
      this.selectedSiteIds = [];
      this.loadTree();

      if (this.model.id != null) {
        this.querySiteNameList(this.model.siteId);
        var reg = /,$/gi;
        this.selectedSiteIds = this.model.siteId.replace(reg, '').split(',').map(Number);
      }

      this.$nextTick(function () {
        var that = _this2;
        that.form.setFieldsValue(pick(that.model, that.form_fields));
      });
    },
    handleOk: function handleOk() {
      var _this3 = this;

      var that = this; // 触发表单验证

      this.form.validateFields(function (err, values) {
        if (!err) {
          that.confirmLoading = true;
          var formData = Object.assign(that.model, values);
          formData.siteId = _this3.siteIds;
          var httpurl = '',
              method = '';

          if (!_this3.model.id) {
            httpurl = _this3.url.add ? _this3.url.add : _this3.pagePath;
            method = 'post';
          } else {
            httpurl = _this3.url.edit ? _this3.url.edit : _this3.pagePath;
            method = 'put';
          }

          httpAction(httpurl, formData, method).then(function (res) {
            if (res.success) {
              that.$notification.success({
                message: res.message
              });
              that.$emit('ok');
              that.close();
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          }).finally(function () {
            that.confirmLoading = false;
          });
        }
      });
    },
    close: function close() {
      this.$emit('close');
      this.type = '';
      this.visible = false;
    }
  }
};